import { VehicleDetailReminderDataInput } from './vehicle-detail-reminder-data-input.model';
import { UserReminderDataInput } from './user-reminder-data-input.model';
import { SmsDataReminderDataInput } from './sms-data-reminder-data-input.model';
import { EmailDataReminderDataInput } from './email-data-reminder-data-input.model';


export class ReminderAddInput implements IReminderAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId!: number;
    /** The branch type must be one of "All" or "Select" */
    branchType!: string;
    /** The vehicle type must be one of "All" or "Selected" */
    vehicleType!: string;
    /** The vehicle type must be one of "All" or "Selected" */
    userType!: string;
    /** The auto-generated id of the maintenance master */
    maintenanceTypeId!: number;
    /** The every month */
    everyMonth!: number;
    /** The every distance */
    everyDistance!: number;
    /** The notify before days */
    notifyBeforeDays!: number;
    /** The notify before distance */
    notifyBeforeDistance!: number;
    /** The description with 5000 character */
    description!: string;
    /** The notification repeat should be Never or Daily */
    notificationRepeat!: string;
    /** The notification time */
    notificationTime!: string;
    /** The mobile app */
    mobileApp!: number;
    /** The sms */
    sms!: number;
    /** The sms */
    email!: number;
    /** The branch detailId */
    branchDetailId!: number;
    vehicleDetailReminderData!: VehicleDetailReminderDataInput[];
    userReminderData!: UserReminderDataInput[];
    smsDataReminderData!: SmsDataReminderDataInput[];
    emailDataReminderData!: EmailDataReminderDataInput[];

    constructor(data?: IReminderAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDetailsId = _data["companyDetailsId"];
            this.branchType = _data["branchType"];
            this.vehicleType = _data["vehicleType"];
            this.userType = _data["userType"];
            this.maintenanceTypeId = _data["maintenanceTypeId"];
            this.everyMonth = _data["everyMonth"];
            this.everyDistance = _data["everyDistance"];
            this.notifyBeforeDays = _data["notifyBeforeDays"];
            this.notifyBeforeDistance = _data["notifyBeforeDistance"];
            this.description = _data["description"];
            this.notificationRepeat = _data["notificationRepeat"];
            this.notificationTime = _data["notificationTime"];
            this.mobileApp = _data["mobileApp"];
            this.sms = _data["sms"];
            this.email = _data["email"];
            this.branchDetailId = _data["branchDetailId"];
            if (Array.isArray(_data["vehicleDetailReminderData"])) {
                this.vehicleDetailReminderData = [] as any;
                for (let item of _data["vehicleDetailReminderData"])
                    this.vehicleDetailReminderData!.push(VehicleDetailReminderDataInput.fromJS(item));
            }
            if (Array.isArray(_data["userReminderData"])) {
                this.userReminderData = [] as any;
                for (let item of _data["userReminderData"])
                    this.userReminderData!.push(UserReminderDataInput.fromJS(item));
            }
            if (Array.isArray(_data["smsDataReminderData"])) {
                this.smsDataReminderData = [] as any;
                for (let item of _data["smsDataReminderData"])
                    this.smsDataReminderData!.push(SmsDataReminderDataInput.fromJS(item));
            }
            if (Array.isArray(_data["emailDataReminderData"])) {
                this.emailDataReminderData = [] as any;
                for (let item of _data["emailDataReminderData"])
                    this.emailDataReminderData!.push(EmailDataReminderDataInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReminderAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDetailsId"] = this.companyDetailsId;
        data["branchType"] = this.branchType;
        data["vehicleType"] = this.vehicleType;
        data["userType"] = this.userType;
        data["maintenanceTypeId"] = this.maintenanceTypeId;
        data["everyMonth"] = this.everyMonth;
        data["everyDistance"] = this.everyDistance;
        data["notifyBeforeDays"] = this.notifyBeforeDays;
        data["notifyBeforeDistance"] = this.notifyBeforeDistance;
        data["description"] = this.description;
        data["notificationRepeat"] = this.notificationRepeat;
        data["notificationTime"] = this.notificationTime;
        data["mobileApp"] = this.mobileApp;
        data["sms"] = this.sms;
        data["email"] = this.email;
        data["branchDetailId"] = this.branchDetailId;
        if (Array.isArray(this.vehicleDetailReminderData)) {
            data["vehicleDetailReminderData"] = [];
            for (let item of this.vehicleDetailReminderData)
                data["vehicleDetailReminderData"].push(item.toJSON());
        }
        if (Array.isArray(this.userReminderData)) {
            data["userReminderData"] = [];
            for (let item of this.userReminderData)
                data["userReminderData"].push(item.toJSON());
        }
        if (Array.isArray(this.smsDataReminderData)) {
            data["smsDataReminderData"] = [];
            for (let item of this.smsDataReminderData)
                data["smsDataReminderData"].push(item.toJSON());
        }
        if (Array.isArray(this.emailDataReminderData)) {
            data["emailDataReminderData"] = [];
            for (let item of this.emailDataReminderData)
                data["emailDataReminderData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IReminderAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId: number;
    /** The branch type must be one of "All" or "Select" */
    branchType: string;
    /** The vehicle type must be one of "All" or "Selected" */
    vehicleType: string;
    /** The vehicle type must be one of "All" or "Selected" */
    userType: string;
    /** The auto-generated id of the maintenance master */
    maintenanceTypeId: number;
    /** The every month */
    everyMonth: number;
    /** The every distance */
    everyDistance: number;
    /** The notify before days */
    notifyBeforeDays: number;
    /** The notify before distance */
    notifyBeforeDistance: number;
    /** The description with 5000 character */
    description: string;
    /** The notification repeat should be Never or Daily */
    notificationRepeat: string;
    /** The notification time */
    notificationTime: string;
    /** The mobile app */
    mobileApp: number;
    /** The sms */
    sms: number;
    /** The sms */
    email: number;
    /** The branch detailId */
    branchDetailId: number;
    vehicleDetailReminderData: VehicleDetailReminderDataInput[];
    userReminderData: UserReminderDataInput[];
    smsDataReminderData: SmsDataReminderDataInput[];
    emailDataReminderData: EmailDataReminderDataInput[];
}

